import { Config } from "../landing-config"
import { ico_picked } from "../map-config"

const maxFileRows = 500;
export const GBA_CONFIG: Config = {
	data: {
		route: "serviziogba",
		page_title: "GPON Business Access",
		service_title: "GPON Business Access",
		service_description: "",
		service_name: "",
		service_slug: "gba",
		errorTimeout: 10000,
		feasibilityModelSingle: false,
		feasibilityEnabled: true,
		api: {
			massiveImport: {
				massiveDetailsPath: "/serviziogba/massivep2p/detail",
				massiveUploadPath: "/serviziogba/massivep2p/upload",
				massiveDownloadPath: "/serviziogba/data/massive/import.xlsx",
				massiveP2pSalesforcePath: "/serviziogba/massivep2p/send-to-salesforce",
                max_file_rows: maxFileRows,
                info_message: null
			},
			p2pPath: "/point/serviziogba/p2p",
			// TODO: attualmente il parametro bboxPath non viene usato, si dovrebbe implementare in landing-page-service.ts
			bboxPath: "/marketing/building",
			buildingSearchParams: {
				service_platform: "GPON_ATTIVA"
			}
		},
		dynamic_aend_name: 'GBA'
	},
	multiple_points: {
		/** true:  show address button on toast */
		variable: true,
		/** > 1 = only to show address toast */
		max: 1,
		points: {
			b_end: {
				default_method: "address",
				switch_methods: true,
				address: true,
				pop: false,
				poi: false,
				pfs: false,
				roe: false,
				coordinates: true,
				id_building: true,
				id_bts_noa: false,
				id_bts_building: false,
				id_school: false,
				city_noa: false,
				city_pop: false,
				city_poi: false,
				city_building: false,
				id_healthcare: false,
				upload: false,
				popAndPoiAutocomplete: false,
				punti_intermedi: false,
				pop_pcn_xpop: false
			},
			a_end: null
		},
		initial_points: ["b_end"]
	},
	map: {
		map_events: ["click", "zoom_changed", "bounds_changed", "dragend", "dblclick"],
		marker_has_label: false,
		marker_default_icon: ico_picked,
		clear_markers_zoom_level: 12
	},
	research_methods: {
		id_building: true,
		id_bts_noa: false,
		id_bts_building: false,
		id_school: false,
		id_healthcare: false,
		punti_intermedi: false,
		pop_pcn_xpop: false
	},
	area_types: ["CoveredAB", "CoveredCD", "CoveredAGF"], // "CoveredFWA" was removed
	area_types_short: null,
	kml: false,
	pop: {
		load: false,
		view_initial: false,
		click: false,
		loadCities: false
	},
	pop_ola: {
        load: false,
        view_initial: false,
        click: false
    },
	pcn: {
		load: false,
		view_initial: false,
		click: false
	},
	pop_agf: {
		load: false,
		view_initial: false,
		click: false
	},
	poi: {
		load: true,
		view_initial: false,
		click: false,
		x_pop: true,
		is_registered: true,
		custom_research_method: "Address",
		loadCities: false
	},
	pfs: {
		load: false,
		view_initial: false,
		click: false,
		type: "PFS"
	},
	roe: {
		load: false,
		view_initial: false,
		click: false,
		type: "ROE"
	},
	cno: {
		load: false,
		view_initial: false,
		click: false,
		type: "CNO"
	},
	pozzetto: {
		load: false,
		view_initial: false,
		click: false,
		type: "POZZETTO"
	},
	building: {
		load: true,
		click: true,
		placeholder: "Insert Building ID"
	},
	noa: {
		load: false,
		click: false,
		placeholder: "Insert NOA ID"
	},
	bts: {
		load: false,
		types: null
	},
	punti_intermedi: {
		load: false,
		types: null
	},
	pop_pcn_xpop: {
		load: false,
		types: null
	},
	school: {
		load: false,
		click: false,
		placeholder: "Insert School ID"
	},
	healthcare: {
		load: false,
		click: false,
		placeholder: "Insert Healthcare ID"
	}
}
